
import { useScrollSpy } from "@/hooks/useScrollSpy";

const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "categories", label: "Categories" },
  { id: "partners", label: "Partners" },
  { id: "customization", label: "Customization" },
  { id: "contact", label: "Contact" },
];

export function ScrollSpyNav() {
  const activeId = useScrollSpy(NAV_LINKS.map((l) => l.id), 80);

  return (
    <nav className="hidden md:flex items-center gap-6">
      {NAV_LINKS.map((nav) => (
        <a
          key={nav.id}
          href={`#${nav.id}`}
          className={`relative text-sm font-medium transition-colors hover:text-primary
              ${activeId === nav.id ? "text-primary" : ""}
            `}
        >
          {nav.label}
          <span
            className={`
              absolute left-0 -bottom-1 h-0.5 w-full
              transition-all duration-300
              ${activeId === nav.id
                ? "bg-[#ff9f1c] scale-x-100"
                : "bg-transparent scale-x-0"
              }
              origin-left
              rounded-full
            `}
          />
        </a>
      ))}
    </nav>
  );
}
